import React from "react";
import "./Map.css";

const MapFunction = () => {
  return (
    <iframe
      width="200"
      height="150"
      src="https://www.google.com/maps?q=barc+shelter+new+york&amp;output=embed"
    ></iframe>
  );
};
export default MapFunction;
